/* istanbul ignore file */
import BaseApi from '@lumapps/base-api';
import { learningApi } from '@lumapps/learning/constants';
import { CatalogLegacy, CategoryLegacy } from '@lumapps/learning/types';

const catalogApi = () =>
    new BaseApi({
        version: BaseApi.versions.v2,
        path: 'learning',
        baseURL: learningApi.URL,
    });
const paths = {
    catalog: 'catalog/v2/categories/all',
    categories: 'catalog/v2/categories/titles',
};

export async function getCatalog(language: string): Promise<CatalogLegacy> {
    const { data } = await catalogApi().get<CatalogLegacy>(paths.catalog, { params: { language } });

    return data;
}

export async function getCategories(language: string): Promise<CategoryLegacy[]> {
    const { data } = await catalogApi().get<CategoryLegacy[]>(paths.categories, { params: { language } });

    return data;
}

export const learningCatalogQueryKeys = (locale: string) => ['learning', 'catalog', locale];
